<template>
  <div class="chips-container d-inline-flex flex-wrap gap-2">
    <div class="chip" v-for="(chip, index) in data" :key="index">
      <div class="chip__text">
        <p>
          {{ chip.name }} - {{ chip.radius}}km
        </p>
      </div>
      <div class="chip__close-btn" @click="closeChip(chip)">
        <p>
          x
        </p>
      </div>
    </div>
  </div>
</template>
<script>

import variables from '@/mixins/variables'

export default {
  name: 'Chip',
  mixins: [variables],
  props: ['data'],
  data () {
    return {

    }
  },
  methods: {
    closeChip (param) {
      this.$emit('update-location', param)
    }
  }
}

</script>
<style>

.chip {
  color: white;
  background: black;
  border-radius: 20px;
  font-size: 13px;
  height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: flex;
  align-items: center;

  p {
    position: relative;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    top: 7px;
  }

  &:hover {
    background: gray;
  }

  .chip__text {
    margin: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .chip__close-btn {
    top: 2px;
    width: 15%;
    text-align: right;
    margin-right: 8px;
    cursor: pointer;
  }
}
</style>
